/**
 * `StatTile`/`StatTiles` — the UC1/UC2 sub-tab headline numbers: a small grid of plain-div
 * tiles (no SVG — task 2 brief §Interfaces explicitly allows divs here), each one number
 * with its unit and a label underneath, an optional caption line below that.
 *
 * Pure and translation-free like the other three chart components in this register
 * (`StackedBar`, `DimensionBars`, `PairedBars`): every string a caller passes in already
 * carries its own unit and period, this component only lays them out.
 */
import type { ReactNode } from 'react';

export interface StatTileProps {
  id: string;
  value: string | number;
  unit?: string;
  label: string;
  sub?: string;
  /** A word or short phrase rather than a number: rendered at text size so it never wraps mid-word. */
  text?: boolean;
}

export function StatTile({ id, value, unit, label, sub, text }: StatTileProps) {
  return (
    <div className="stat-tile" data-testid={`stat-${id}`}>
      <div className={text ? 'stat-value stat-value-text' : 'stat-value'}>
        {value}
        <span className="stat-unit">{unit}</span>
      </div>
      <div className="stat-label">{label}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}

export interface StatTilesProps {
  children: ReactNode;
}

export function StatTiles({ children }: StatTilesProps) {
  return <div className="stat-tiles">{children}</div>;
}

export default StatTile;
